import React from "react";
import { Select } from "@/components/Select";

const intervalOptions = [
  {
    value: 1,
    key: "1_month",
    label: "1 Month",
  },
  {
    value: 2,
    key: "2_month",
    label: "2 Months",
  },
  {
    value: 3,
    key: "3_month",
    label: "3 Months",
  },
  {
    value: 4,
    key: "4_month",
    label: "4 Months",
  },
  {
    value: 5,
    key: "5_month",
    label: "5 Months",
  },
  {
    value: 6,
    key: "6_month",
    label: "6 Months",
  },
  {
    value: 7,
    key: "7_month",
    label: "7 Months",
  },
  {
    value: 8,
    key: "8_month",
    label: "8 Months",
  },
  {
    value: 9,
    key: "9_month",
    label: "9 Months",
  },
  {
    value: 10,
    key: "10_month",
    label: "10 Months",
  },
  {
    value: 11,
    key: "11_month",
    label: "11 Months",
  },
  {
    value: 12,
    key: "12_month",
    label: "12 Months",
  },
];

interface IntervalSelectorProps<T extends {}> {
  value: T;
  label?: string;
  onChange?: ((value: null | T) => void) | undefined;
}

const SubscriptionMonthIntervalSelector = ({
  value,
  label,
  onChange,
}: IntervalSelectorProps<number>) => {
  return (
    <>
      <Select
        label={label}
        options={intervalOptions}
        value={value}
        defaultValue={intervalOptions[3].value}
        onChange={(_, value) => onChange?.(value)}
      />
    </>
  );
};

export { SubscriptionMonthIntervalSelector as IntervalSelector };
